<template>
  <div class="el-input" :class="{ 'el-input--suffix': showSuffix }">
    <input type="type" class="el-input__inner" :placeholder="placeholder" :name="name" :disabled="disabled"
      :class="{ 'is-disabled': disabled }" :value="value" @input="handleinput" />
    <span class="el-input__suffix" v-if="showSuffix">
      <span class="el-input__suffix-inner">
        <i v-if="clearable && value" class="el-input__icon el-icon-circle-close el-input-clear" @click="clear"></i>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'DiyInput',
  props: {
    placeholder: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    name: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      passwordVisiable: false // 控制是否显示密码
    }
  },
  computed: {
    showSuffix () {
      return this.clearable
    }
  },
  methods: {
    handleinput (event) {
      this.$emit('input', event.target.value)
    },
    clear () {
      this.$emit('input', '')
    }
  }
}
</script>

<style lang="less" scoped>
.el-input__suffix-inner {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/virtualTree/src/diyInput.vue